import { LoggerFactory } from "lego-gui-lib/lib";
import { VisibilityType } from "../../common/common";
import { showErrorMessage } from "../../feature/tree/treeBlock/schema/validators";
import { mainStore } from "../mainStore";
import { Auth } from "./auth";

class AuthSchemaHelper {
  private auth: Auth;
  private customer: typeof mainStore.customer;

  private log = LoggerFactory.create("AuthSchemaHelper");

  public constructor(auth: Auth, customer: typeof mainStore.customer) {
    this.auth = auth;
    this.customer = customer;
  }

  public prepareInitialValuesForAnyCustomerOwnerCreate = (
    domain: any,
    initialValues?: typeof domain.schema
  ) => {
    const result: typeof domain.schema = { ...initialValues };
    if (!this.auth.isAdmin()) {
      result.visibility = VisibilityType.PRIVATE;
    }
    /** Due to role CR SAN Admin and Customer Owner are allowed to operate as one of his clients, so customerRef switch is needed */
    if (this.auth.isAnyCustomerOwner() && this.customer.oneDataSource?.one) {
      try {
        result.customerRef = this.customer.oneDataSource.one?.id;
      } catch (e) {
        this.log.error("failed to load customerRef", e);
        showErrorMessage("hns:initWithFirstFailed");
      }
    }
    return result;
  };
}

export const authSchemaHelper = new AuthSchemaHelper(
  mainStore.auth,
  mainStore.customer
);
